/**
 * Build-time import of self-contained voiceorb HTML (three.min.js inlined).
 * Generated by the bundle:voiceorb npm script.
 * Web: used as iframe srcdoc (avoids auth proxy interception on Harmony).
 */
import bundle from "./voiceorb-bundle.json";
export default bundle.html;
